import type { FirstPartyTrafficQuery } from '@/api/firstPartyTraffic'
import type { Ga4TrafficQuery } from '@/api/types'

/** The name the API gives the same file (`traffic-<group_by>-<from>-to-<to>.csv`), since a fetched download loses its header. */
export function csvFilename(query: Ga4TrafficQuery): string {
  return `traffic-${query.groupBy}-${query.from}-to-${query.to}.csv`
}

/** The name the API gives the first-party file (`traffic-tmt-<model>-<level>-<from>-to-<to>.csv`). */
export function firstPartyCsvFilename(query: FirstPartyTrafficQuery): string {
  return `traffic-tmt-${query.model}-${query.level}-${query.from}-to-${query.to}.csv`
}

/** Hands a fetched file to the browser as a download (`@/lib/download`), re-exported for the pages that import it here. */
export { saveBlob } from '@/lib/download'
